import { render, staticRenderFns } from "./Todo.vue?vue&type=template&id=e9a978fa&scoped=true&"
import script from "./Todo.vue?vue&type=script&lang=js&"
export * from "./Todo.vue?vue&type=script&lang=js&"
import style0 from "./Todo.vue?vue&type=style&index=0&id=e9a978fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a978fa",
  null
  
)

export default component.exports